import { serviceName } from '../resources/serviceConstants';
import {
  ADD_EDIT_TARGETS,
  DELETE_TARGET,
  GET_TARGETS,
} from '../resources/endPoint';

export const getTargets = (year) => {
  const url = GET_TARGETS.replace('{year}', year);
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const addTargetData = (
  vertical_id,
  certification_id,
  certification_target,
  financial_year,
  quarter,
  last_updated_by,
) => {
  const data = {
    verticalId: vertical_id,
    certificationId: certification_id,
    certificationTarget: certification_target,
    financialYear: financial_year,
    quarter: quarter,
    lastUpdatedBy: last_updated_by,
  };

  return {
    url: ADD_EDIT_TARGETS,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const editTargetData = (
  target_id,
  vertical_id,
  certification_id,
  certification_target,
  financial_year,
  quarter,
  last_updated_by,
) => {
  const data = {
    targetId: target_id,
    verticalId: vertical_id,
    certificationId: certification_id,
    certificationTarget: certification_target,
    financialYear: financial_year,
    quarter: quarter,
    lastUpdatedBy: last_updated_by,
  };

  return {
    url: ADD_EDIT_TARGETS,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.CERTIFICATIONS_MS,
  };
};

export const deleteTargetData = (target_id, last_updated_by) => {
  const data = {
    targetId: target_id,
    lastUpdatedBy: last_updated_by,
  };

  return {
    url: DELETE_TARGET,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.CERTIFICATIONS_MS,
  };
};
